import { render, staticRenderFns } from "./GuidesIndex.vue?vue&type=template&id=415c50cb&scoped=true"
import script from "./GuidesIndex.vue?vue&type=script&lang=js"
export * from "./GuidesIndex.vue?vue&type=script&lang=js"
import style0 from "./GuidesIndex.vue?vue&type=style&index=0&id=415c50cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c50cb",
  null
  
)

export default component.exports